// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM13 14V6H11V14H13ZM18 14V9H16V14H18ZM8 14V11H6V14H8Z"}}]};

const ChatPollFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-poll-filled',
    ref,
    icon: element,
  },
));

ChatPollFilledIcon.displayName = 'ChatPollFilledIcon';

export default ChatPollFilledIcon;
